export default __webpack_public_path__ + "static/media/card-profile1-square.78a01818.jpg";